import { ShowConsultations } from './show-consultations';

export default ShowConsultations;